const API_ROOT = process.env.REACT_APP_API_ROOT;
const MOUNT_POINT = process.env.REACT_APP_MOUNT_POINT;

const conf = {
	API_ROOT
	,MOUNT_POINT
	,FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL

	,apis: {
		user: {
			login: API_ROOT + '/AppUsers/login'
			,logout: API_ROOT + '/AppUsers/logout'
			,requestPasswordReset: API_ROOT + '/AppUsers/reset'
			,resetPassword: API_ROOT + '/AppUsers/reset-password'
			,verify: (userId) => `${API_ROOT}/AppUsers/${userId}/verify`
			,current: API_ROOT + '/AppUsers/me'
			,find: API_ROOT + '/AppUsers'
			,create: API_ROOT + '/AppUsers'
			,update: (userId) => `${API_ROOT}/AppUsers/${userId}`
			,findById: (userId) => `${API_ROOT}/AppUsers/${userId}`
			,delete: (userId) => `${API_ROOT}/AppUsers/${userId}`
		}

		,projects: {
			find: API_ROOT + '/Projects'
			,create: API_ROOT + '/Projects'
			,update: (id) => `${API_ROOT}/Projects/${id}`
			,findById: (id) => `${API_ROOT}/Projects/${id}`
			,delete: (id) => `${API_ROOT}/Projects/${id}`
			,uploadFile: `${API_ROOT}/ShippingItems/upload`
		}

		,roles: {
			find: API_ROOT + '/Roles'
		}

		,roleMappings: {
			create: API_ROOT + '/RoleMappings'
		}
	}
};

export default conf;
